

















import {Component, Vue} from "vue-property-decorator";
import LogsParserService from "@/services/LogsParserService";

@Component
export default class LogsParser extends Vue {
    public logFile: File | null =  null;
    public parser = new LogsParserService();
    public games = 0;
    public scoreForVictory: number = 10;

    public async parse() {
        if (this.logFile != null) {
          let scoreForVictory = Number(this.scoreForVictory);
          await this.parser.parseFile(this.logFile, {scoreForVictory: scoreForVictory, teamSwitch: scoreForVictory > 10});
            // @ts-ignore
            this.games = window.games.length;
        }
    }

    public checkFile() {
        this.logFile = (this.$refs.logFile as any).files[0];
    }

    public copy() {
        const el = document.createElement("textarea");
        // @ts-ignore
        const lastGame = window.games[window.games.length - 1];
        el.value = JSON.stringify(lastGame);
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        alert("copied");
    }
}
